import { Select } from 'antd';
import React from 'react';
import ReactCountryFlag from 'react-country-flag';
import { LANGUAGES } from '../../../../../utils/const/languages';

const LanguageSelector = ({
  selectedLanguage,
  value,
  onChange,
  style,
  disabled,
}) => {
  const currentValue = value ?? selectedLanguage;
  const options = LANGUAGES.map((lang) => ({
    label: (
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
        <ReactCountryFlag
          countryCode={lang.countryCode}
          svg
          style={{
            width: '1.5em',
            height: '1.5em',
          }}
        />
        {lang.label}
      </div>
    ),
    value: lang.code,
  }));

  return (
    <Select
      allowClear
      style={{ width: '100%', ...style }}
      placeholder="Sélectionner une langue"
      options={options}
      value={currentValue}
      disabled={disabled}
      onChange={onChange}
      optionLabelProp="label"
    />
  );
};

export default LanguageSelector;
